<template>
  <div class="container is-uppercase has-text-weight-bold">
    <Header/>
    <div class="section">
      <h1>{{ $t('Write MSISDN to login') }}</h1>
      <p><input type="phone" class="input m-sm" v-model="phone" style="width:70%">
      <input type="submit" class="m-sm button" @click="send" :value="$t('Continue')"></p>
    </div>
    <Footer/>
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Login',
  data () {
    return {
      phone: ''
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'open') {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    send() {
      const arr = this.phone.split(' ').join('').match(/^(\+30|0030|030|0|30)?(69[0-9]{8})$/)
      console.log(this.phone, arr)
      if (arr !== null) {
          document.location.replace(`${ this.$store.getters.host }/${ this.$store.getters.apiPrefix }/mi/gr/0030${ arr[2] }`) 
      }
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/Login.vue